import React from 'react';
import { InputLabelContainer } from '../../label/containers/input-label.container';
import { InputErrorContainer } from '../../error/containers/input-error.container';

export function SelectInputComponent ({
  label,
  options,
  onValueChange,
  isDisabled,
  error,
  noMargin,
  onClick,
  isRequired,
  searchValue,
  value,
  optionName
}: any) {

  return (
    <div
        onClick={(event) => onClick && onClick(event)}
        style={{ marginBottom: noMargin ? 0 : undefined }}
    >
      <InputLabelContainer
          isRequired={isRequired}
          label={label}
      />
<select
  className={`w-full px-4 py-2 border rounded-md ${isDisabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500'}`}
  disabled={isDisabled}
  onChange={(event) => onValueChange(event)}
  required={isRequired}
  value={value}
  
>
<option value="">{optionName}</option>
  {options.map((option:any) => (
    <option  value={option.value}>
      {option.label}
    </option> ))}
</select>
      <InputErrorContainer error={error} />

    </div>
  );
}
